var React = require('react');

function EditWhite (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_4429","data-name":"Ellipse 4429","cx":"16","cy":"16","r":"16","fill":"#fff","key":0}),React.createElement("g",{"id":"Group_44765","data-name":"Group 44765","transform":"translate(-1488 -266)","key":1},[React.createElement("rect",{"id":"Rectangle_37823","data-name":"Rectangle 37823","width":"22","height":"22","transform":"translate(1493 271)","fill":"none","key":0}),React.createElement("path",{"id":"pencil-r","d":"M16.45,2.247l5.3,5.3L8.982,20.321h-5.3v-5.3Zm0,2.121L14.673,6.145l3.182,3.182L19.632,7.55Zm.345,6.019L13.612,7.205,5.179,15.639v3.182H8.361Z","transform":"translate(1491.321 270.753)","fillRule":"evenodd","key":1})])]);
}

EditWhite.defaultProps = {"id":"edit","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = EditWhite;

EditWhite.default = EditWhite;
